import React, { ReactNode, useState } from 'react';

// Material ui
import { Grid, Popover } from '@material-ui/core';

// Components
import Button from '@components/UI-KIT/Button';

// Icons
import {
    Download,
    Filter,
    List
} from '@/assets/icons';

// Styles
import VARIABLES from '@/assets/variables';

interface Props {
    filters?: ReactNode;
    columns?: ReactNode;
    download?: ReactNode;
    downloadExcel?: () => void;
    disableDownloadExcel?: boolean;
    filtersApplied?: boolean;
}

type buttonType = 'filters' | 'columns' | 'download' | 'downloadExcel';

const TableMenu: React.FC<Props> = ({
    filters,
    columns,
    download,
    downloadExcel,
    disableDownloadExcel,
    filtersApplied
}) => {
    const [ currentButton, setCurrentButton ] = useState<buttonType>('filters');
    const [ anchorEl, setAnchorEl ] = useState<HTMLButtonElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'ui-table-menu' : undefined;

    return (
        <Grid
            container
            justify="flex-end"
            wrap="nowrap"
        >
            { downloadExcel && (
                <Grid
                    item
                    style={{
                        padding: '0 1rem',
                        alignSelf: 'center'
                    }}
                >
                    <Button
                        onClick={() => downloadExcel()}
                        level={4}
                        label="Descargar Excel"
                        disabled={disableDownloadExcel === undefined ? false : disableDownloadExcel}
                        icon={(
                            <Download
                                color={VARIABLES.palette.secondary_color}
                            />
                        )}
                    />
                </Grid>
            )}
            { filters && (
                <Grid
                    item
                    style={{
                        padding: '0 1rem',
                        alignSelf: 'center'
                    }}
                >
                    <Button
                        onClick={e => {
                            setAnchorEl(e.currentTarget);
                            setCurrentButton('filters');
                        }}
                        level={4}
                        label="Filtros"
                        icon={(
                            <Filter
                                color={VARIABLES.palette.secondary_color}
                                applied={filtersApplied}
                            />
                        )}
                    />
                </Grid>
            )}
            { columns && (
                <Grid
                    item
                    style={{
                        padding: '0 1rem',
                        alignSelf: 'center',
                        borderLeft: '1px solid #D7DBF1',
                        borderRight: '1px solid #D7DBF1'
                    }}
                >
                    <Button
                        onClick={e => {
                            setAnchorEl(e.currentTarget);
                            setCurrentButton('columns');
                        }}
                        level={4}
                        label="Personalizar columnas"
                        icon={(
                            <List
                                color={VARIABLES.palette.secondary_color}
                            />
                        )}
                    />
                </Grid>
            )}
            { download && (
                <Grid
                    item
                    style={{
                        padding: '0 1rem',
                        alignSelf: 'center'
                    }}
                >
                    <Button
                        onClick={e => {
                            setAnchorEl(e.currentTarget);
                            setCurrentButton('download');
                        }}
                        level={4}
                        label="Descargar"
                        icon={(
                            <Download
                                color={VARIABLES.palette.secondary_color}
                            />
                        )}
                    />
                </Grid>
            )}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                classes={{
                    paper: `ui-Table-menu-${currentButton}-popover`
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <Grid
                    className={`ui-Table-menu-${currentButton}-children`}
                >
                    {currentButton === 'filters' && filters}
                    {currentButton === 'columns' && columns}
                    {currentButton === 'download' && download}
                </Grid>
            </Popover>
        </Grid>
    );
};

export default TableMenu;
